module.exports = __webpack_public_path__ + "img/logo.648cd406.png";